// import "@fontsource/dm-sans"
// import "@fontsource/dm-sans/500.css"
// import "@fontsource/dm-sans/700.css"
// import "@fontsource/dm-mono"
// import "@fontsource/dm-mono/500.css"

import { wrapWithProvider, wrapWithPage } from './gatsby-wrapper'
import ReactDOM from "react-dom/client";

export const wrapRootElement = wrapWithProvider
export const wrapPageElement = wrapWithPage


export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

